import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { User, UsersResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class UsersDataService {

  private uri: string = `${environment.apiUrl}users`;
  private cacheKey: string = 'users.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getUser(id: number): Observable<User|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getUsers(parameters: {[param: string]: string | string[]}): Observable<UsersResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addUser(data: User): Observable<User|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addUsers(data: User[]): Observable<User[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateUser(data: User): Observable<User|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateUsers(data: User[]): Observable<User[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchUser(data: User): Observable<User|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchUsers(data: User[]): Observable<User[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteUser(data: User): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteUsers(data: User[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((user) => {
      ids.push(user.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
